export const SessionToken = (state) => {
  return state.CurrentSession.Token
}

export const SessionAccount = (state) => {
  return state.CurrentSession.Account
}

export const SessionConfig = (state) => {
  return state.CurrentSession.Config
}

export const SessionGroupSecurity = (state) => {
  return state.CurrentSession.GroupSecurity
}

export const SessionSettings = (state) => {
  return state.CurrentSession.Settings
}

export const currentPath = (state) => {
  return state.router.location.pathname
}
